<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <popup-select
    id="hospital-select"
    ref="popupSelect"
    v-model="selectedHospital"
    @selected="changeHospital"
    :custom="true"
    :title="'选择医院'"
    :forced="forced"
  >
    <slot>
      <ul class="list list-select">
        <li class="list-item">
          <div
            id="hospitalSelect-div-hospitalName"
            class="hospital arr-row ellipsis"
          >
            {{ selectedHospital.hospitalName }}
          </div>
        </li>
      </ul>
    </slot>
    <div id="hospitalSelect-tree" slot="custom">
      <div class="input-hospital" @click.stop="stopClink">
        <i class="icon-search"></i>
        <input
          class="input-search"
          type="text"
          placeholder="请输入您想要搜索的医院"
          v-model="inputText"
          @click="contrastText"
        />
      </div>
      <!--<index-bar></index-bar>-->
      <ul
        v-if="selectedHospital.hospitalName && channel !== 'TFY'"
        class="list list-header"
      >
        <li
          @click="close(selectedHospital)"
          class="list-item last ellipsis"
          id="hospitalSelect-li-continue"
        >
          <span>上次选择：{{ selectedHospital.hospitalName }}</span>
          <span class="continue">继续</span>
        </li>
      </ul>
      <ul
        v-if="
          selectedHospital.hospitalName &&
          channel === 'TFY' &&
          selectedHospital.hospitalId !== CDFYId
        "
        class="list list-header"
      >
        <li
          @click="close(selectedHospital)"
          class="list-item last ellipsis"
          id="hospitalSelect-li-continue"
        >
          上次选择：{{ selectedHospital.hospitalName }}
          <span class="continue">继续</span>
        </li>
      </ul>
      <!-- v：医院信息数组（相同字母索引），k：字母索引，i：数组下标 -->
      <ul
        v-if="!isChoose"
        v-for="(v, k, i) of hospitalList"
        :key="i"
        class="list"
      >
        <!--<li class="header">-->
        <!--<a :id="'header' + k">{{k}}</a>-->
        <!--</li>-->
        <!-- vv：医院信息，ii：数组下标 -->
        <li
          class="list-item arr-row"
          v-for="(vv, ii) of v"
          :key="ii"
          :id="'hospitalSelect-li-hospital-' + vv.hospitalId"
          @click="select(vv)"
        >
          <div class="hospital-info">
            <div
              class="logo"
              v-bind:style="{ backgroundImage: 'url(' + vv.hospitalLogo + ')' }"
            ></div>
            <div class="info">
              <p class="f-large f-normal ellipsis">{{ vv.hospitalName }}</p>
              <p class="f-small f-dark-gray ellipsis">{{ vv.hospitalAddr }}</p>
            </div>
          </div>
        </li>
      </ul>
      <ul v-if="isChoose" v-for="(v, k, i) of tempList" :key="i" class="list">
        <!--<li class="header">-->
        <!--<a :id="'header' + k">{{k}}</a>-->
        <!--</li>-->
        <!-- vv：医院信息，ii：数组下标 -->
        <li
          class="list-item def arr-row"
          v-for="(vv, ii) of v"
          :key="ii"
          :id="'hospitalSelect-li-hospital-' + vv.hospitalId"
          @click="select(vv)"
        >
          <div class="hospital-info">
            <div
              class="logo"
              v-bind:style="{ backgroundImage: 'url(' + vv.hospitalLogo + ')' }"
            ></div>
            <div class="info">
              <p class="f-large f-normal ellipsis">{{ vv.hospitalName }}</p>
              <p class="f-small f-dark-gray ellipsis">{{ vv.hospitalAddr }}</p>
            </div>
          </div>
        </li>
      </ul>
      <no-record
        id="myregister-norecord"
        :condition="hospitalList"
        tips="抱歉，暂无医院列表信息"
      ></no-record>
    </div>
  </popup-select>
</template>
<script>
import hospitals from 'hospital.service'
import IndexBar from 'IndexBar'
import NoRecord from 'NoRecord'
export default {
  components: {
    IndexBar,
    NoRecord
  },
  created () {
    this.refresh();
    this.CDFYId = this.constant.HOSPITAL_ID.CDFY
  },
  props: {
    // 没选中任何医院时，是否强制打开医院选择
    noSelectedOpen: {
      type: Boolean,
      default: function () {
        return true;
      }
    },
    // 点击继续后等同于进行了医院选择
    continueSelect: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    // 是否永远显示
    alwaysOpen: {
      type: Boolean,
      default: function () {
        return false;
      }
    }
  },
  data: function () {
    var selected = localStorage.selectedHospital;
    return {
      msg: '',
      forced: this.alwaysOpen ? true : (this.noSelectedOpen ? !selected : false),
      hospitalList: [],
      channel: localStorage.channel,
      areaType: sessionStorage.areaType,
      selectedHospital: selected ? JSON.parse(selected) : {},
      inputText: '',
      isChoose: false,
      CDFYId: ''
    }
  },
  computed: {
    //返回查询后的医院列表
    tempList () {
      let temp = []
      if (this.hospitalList.length !== 0) {
        let hospitals = this.hospitalList['医院']
        let inputList = this.inputText.split('')
        //关键字比较
        for (let i = 0; i < hospitals.length; i++) {
          let flag = true
          for (let j = 0; j < inputList.length; j++) {
            //如果有一个字不匹配则为false
            if (hospitals[i].hospitalName.indexOf(inputList[j]) == -1) {
              flag = false
            }
          }
          //保存匹配后的数组
          if (flag) {
            temp.push(hospitals[i])
          }
        }
        return { '医院': temp }
      }
    }
  },
  methods: {
    close (selectedHospital) {
      if (this.continueSelect) {
        let hospitals = this.hospitalList['医院']
        for (let i = 0; i < hospitals.length; i++) {
          if (selectedHospital.hospitalName === hospitals[i].hospitalName) {
            selectedHospital.jumpAddr = hospitals[i].jumpAddr
          }
        }

        localStorage.selectedHospital = JSON.stringify(selectedHospital);
        this.$emit('selected', selectedHospital, false);
        return;
      }
    },
    select (v, isHospitalChanged) {
      this.$refs.popupSelect.select(v, isHospitalChanged);
    },
    refresh () {
      hospitals.getAll().then((res) => {
        this.hospitalList = res;
        //市民云隐藏成都大学附属医院
        if (this.channel !== 'WX') {
          let outHospitalList = []
          for (let i = 0; i < this.hospitalList['医院'].length; i++) {
            if (this.hospitalList['医院'][i].hospitalId !== this.CDFYId) {
              outHospitalList.push(this.hospitalList['医院'][i])
            }
          }
          this.hospitalList['医院'] = outHospitalList
        }
      });
    },
    changeHospital (hospital) {
      var oldSelect = localStorage.selectedHospital;
      var oldSelectHospital = oldSelect ? JSON.parse(oldSelect) : {};
      var isHospitalChanged = oldSelectHospital.hospitalId !== hospital.hospitalId;

      this.selectedHospital = hospital;
      localStorage.selectedHospital = JSON.stringify(hospital);
      http.headers.common['hospitalId'] = hospital.hospitalId;
      this.$emit('selected', hospital, isHospitalChanged);
      this.forced = false;
    },
    stopClink (e) {
      e.preventDefault()
    },
    contrastText () {
      this.isChoose = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../static/sass/_variable.scss";
.app {
  .input-hospital {
    position: relative;
    height: 1.5rem;
    line-height: 1.5rem;
    background-color: $main-style-color;
    display: flex;
    .icon-search {
      position: absolute;
      background: url(../../static/img/icon-search.png) no-repeat;
      background-size: 100% 100%;
      left: 0.7rem;
      top: 0.4rem;
      width: 0.6rem;
      height: 0.6rem;
    }
    .input-search {
      height: 1rem;
      width: 90%;
      padding: 0 1rem;
      display: block;
      margin: 0 auto;
      border-radius: 18px;
      align-self: center;
      outline: none;
      border: none;
    }
  }
}
</style>

<style lang="scss">
@import "../../static/sass/_variable.scss";
.list-select {
  .list-item {
    .hospital {
      background: url(../../static/img/hospital-icon.png) left center no-repeat;
      background-size: auto 100%;
    }
  }
}
.list {
  .list-item {
    &.def {
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
    &.last {
      padding-right: 0.5rem !important;
      color: $main-style-color;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .continue {
        padding-right: 0.5rem;
        color: $main-style-color;
        background: url(../../static/img/more-right-blue.png) right center
          no-repeat;
        background-size: 0.2rem 0.4rem;
      }
    }
  }
}
.list-header {
  background-color: #e1edfb;
}
.header {
  padding-top: 0.13rem;
  padding-bottom: 0.13rem;
  color: #999;
  font-size: 0.65rem !important;
  background-color: #eff2f5;
}
.border-none {
  li:first-child,
  li:last-child {
    border-bottom: none;
  }
}
.hospital-info {
  @include display-flex();
  @include align-items(center);
  .logo {
    width: 1.5rem;
    height: 1.5rem;
    background-image: url(../../static/img/hos-def-logo.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .info {
    @include flex(1);
    @include ellipsis();
    width: 1px;
    padding-left: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// HospitalSelect.vue?72df4444